import React from 'react';

const letterSeq = [
  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P',
  'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '0-99',
];

const Letter = ({
  activateLetter, activeLetter, letter, letters,
}) => (
  <div key={letter} className="letter">
    {
      (letters.indexOf(letter) === -1)
        ? <span className=""><span>{letter}</span></span>
        : (
          <span
            onClick={event => activateLetter(event, letter)}
            className={activeLetter === letter ? 'letter-link active' : 'letter-link'}
          >
            <span>{letter}</span>
          </span>
        )
    }
  </div>
);

export default ({ activateLetter, activeLetter, letters }) => (
  <div className="letter-filter">
    {letterSeq.map(letter => (
      <Letter
        activateLetter={activateLetter}
        activeLetter={activeLetter}
        letter={letter}
        letters={letters}
        key={letter}
      />
    ))}
  </div>
);
